import { PaymentEvent as e } from "./PaymentEvent.mjs";
import { z as t } from "zod";
//#region src/verticals/payments/PaymentEventPayloads.ts
var n = t.enum([
	"EGP",
	"USD",
	"EUR"
]), r = t.enum([
	"card",
	"wallet",
	"bank_transfer"
]), i = t.object({
	bookingId: t.string().uuid(),
	amount: t.number().positive(),
	currency: n
}), a = t.object({
	bookingId: t.string().uuid(),
	method: r
}), o = t.object({
	transactionId: t.string().uuid(),
	bookingId: t.string().uuid(),
	amount: t.number().positive(),
	currency: n,
	method: r
}), s = t.object({
	bookingId: t.string().uuid(),
	amount: t.number().positive(),
	currency: n,
	reason: t.string()
}), c = t.object({
	transactionId: t.string().uuid(),
	amount: t.number().positive(),
	currency: n
}), l = t.object({ source: t.string().optional() }), u = {
	[e.CheckoutStarted]: i,
	[e.MethodSelected]: a,
	[e.TransactionCompleted]: o,
	[e.TransactionFailed]: s,
	[e.RefundInitiated]: c,
	[e.CheckoutPageViewed]: l
};
//#endregion
export { u as PaymentEventSchemas };
